import FilesDownloadForm from './download-file-form'

export const CreateFile = ({
  onCloseModal,
}: {
  onCloseModal: () => void
}) => {
  return <FilesDownloadForm onCloseModal={onCloseModal} />
}
